import { captureEvent } from '../../lib/posthog';

const TIPS = [
  {
    icon: 'people',
    title: 'Your contacts, enriched',
    description: 'Clawer builds profiles from your conversations — relationships, facts, and history.',
  },
  {
    icon: 'notifications_active',
    title: 'Smart nudges',
    description: 'Get reminded to follow up with people before relationships go cold.',
  },
  {
    icon: 'auto_stories',
    title: 'Weekly reflections',
    description: 'AI-powered coaching that helps you understand your communication patterns.',
  },
];

interface ManagedWelcomeStepProps {
  displayName?: string;
  onNext: () => void;
}

export function ManagedWelcomeStep({ displayName, onNext }: ManagedWelcomeStepProps) {
  function handleNext() {
    captureEvent('setup_welcome_completed', {});
    onNext();
  }

  return (
    <div>
      <div className="text-center mb-6">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-accent-bg mb-3">
          <span className="material-icons-round text-accent text-2xl">waving_hand</span>
        </div>
        <h1 className="text-2xl font-bold text-ink" data-ph-no-mask>
          {displayName ? `Hey ${displayName}, let\u2019s set up Clawer` : 'Welcome to Clawer'}
        </h1>
        <p className="text-sm text-ink-secondary mt-1" data-ph-no-mask>
          Here&apos;s what you can expect.
        </p>
      </div>

      <div className="space-y-4 mb-8">
        {TIPS.map((tip) => (
          <div key={tip.icon} className="flex items-start gap-3">
            <div className="w-9 h-9 rounded-xl bg-canvas flex items-center justify-center flex-shrink-0">
              <span className="material-icons-round text-accent text-lg">{tip.icon}</span>
            </div>
            <div>
              <p className="text-sm font-semibold text-ink" data-ph-no-mask>{tip.title}</p>
              <p className="text-xs text-ink-secondary mt-0.5 leading-relaxed" data-ph-no-mask>
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <button
        onClick={handleNext}
        className="w-full px-5 py-2.5 rounded-lg bg-accent text-white text-sm font-medium hover:bg-accent-deep transition-colors"
        data-ph-no-mask
      >
        Let&apos;s go
      </button>
    </div>
  );
}
